import { DatePipe } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { InPlaceEditorComponent } from '@syncfusion/ej2-angular-inplace-editor';
import { fadeInOut } from '../../../../shared/helpers/animations';
import { ILLGenericKeys, ILLProduct } from '../../../../shared/models';
import { ILLFormDetail } from '../../../../shared/models/ll-form-detail.model';
import { LLFormService } from '../../../../shared/services/ll-form.service';
import { Utilities } from '../../../../shared/services/utilities';

@Component({
    selector: 'app-ll-form-product-details',
    templateUrl: './ll-form-product-details.component.html',
    styleUrls: ['./ll-form-product-details.component.scss'],
    animations: [fadeInOut],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LLFormProductDetailsComponent implements OnInit, OnChanges {
    selectedDosageValue: string;

    constructor (
        private fb: UntypedFormBuilder, private llService: LLFormService, public datepipe: DatePipe,
        private utilService: Utilities) {
    }

    @ViewChild('inplace_editor_ProprietaryName') public ieProprietaryName: InPlaceEditorComponent;

  @ViewChild('ipeDosage') public ipeDosage: InPlaceEditorComponent;
  @ViewChild('inplace_editor_proprietaryNameSuffix') public ipeSuffix: InPlaceEditorComponent;
  @ViewChild('inplace_editor_estabGenericNameObj') public ipeGenericName: InPlaceEditorComponent;

    @Input() revisionId: string;
    @Input() llFormData: ILLFormDetail;
    @Input() prodIndex: number;
    @Input() partIndex: number;
    @Input() isPart: boolean;
    @Input() titleText: string;
    @Input() productId: number;
    @Output() proprietaryNameOutput = new EventEmitter<any>();

    dataProductDetail: ILLProduct = new ILLProduct();
    public frmProductDetails: UntypedFormGroup;
    productTypes: ILLGenericKeys[];
    dosageFormLOV: ILLGenericKeys[];
    allLOV: any[];
    errorMessage: string;
    dosageFormModel: object;
    proprietaryNameModel: object;
    proprietaryNameSuffixModel: object;
    genericNameModel: object;
    submitted = false;
    loading = false;
    dataLLFormDetail: ILLFormDetail = new ILLFormDetail();
  selectedDosageId: any = null;

    ngOnInit(): void {

        this.frmProductDetails = this.fb.group({
            proprietaryName: ['', { updateOn: 'blur' }],
            proprietaryNameSuffix: ['', { updateOn: 'blur' }],
            genericName: ['', { updateOn: 'blur' }],
            selectedDosage: ['', { updateOn: 'blur' }]
        });


        this.proprietaryNameModel = {
            placeholder: 'Enter Proprietary Name',
          created: this.onTextBoxCreateProprietaryName.bind(this)
        };
        this.proprietaryNameSuffixModel = {
          placeholder: 'Enter Proprietary Name Suffix',
          created: this.onTextBoxCreateSuffix.bind(this)
        };
        this.genericNameModel = {
            placeholder: 'Enter Established Generic Name',
            created: this.onTextBoxCreateGenericName.bind(this)
        };

        this.loadData();

        // Watches changes on the entire form
      this.frmProductDetails.valueChanges.subscribe(data => {

        this.frmProductDetails.value.genericName = data?.genericName ? this.decodeHtml(data.genericName).toString() : '';
        this.frmProductDetails.value.proprietaryName = data?.proprietaryName ? this.decodeHtml(data.proprietaryName).toString() : '';
        this.frmProductDetails.value.proprietaryNameSuffix = data?.proprietaryNameSuffix ? this.decodeHtml(data.proprietaryNameSuffix).toString() : '';

            this.llService.llFormProductDetailsSubject.next(this.frmProductDetails.value);
            this.proprietaryNameOutput.emit(this.frmProductDetails.value.proprietaryName);
        });

        this.llService.llFormProductDetailsSubject.next(this.frmProductDetails.value);
    }
  public onActionSuccess(args) {
    args.value = args.value === null ? '' : this.encodeHtml(args.value);
    }
  public onTextBoxCreateProprietaryName(args) {

    const val = (this.ieProprietaryName as any).value;
    const ctrl = (this.ieProprietaryName as any).containerEle.querySelector('.e-textbox').ej2_instances[0];
    ctrl.value = '';
    if (val) {
        ctrl.value = this.decodeHtml(val);
    }
  }

  public onTextBoxCreateSuffix(args) {

    const val = (this.ipeSuffix as any).value;
    const ctrl = (this.ipeSuffix as any).containerEle.querySelector(
      '.e-textbox'
    ).ej2_instances[0];

    ctrl.value = '';
    if (val) {
      ctrl.value = this.decodeHtml(val);
    }
  }

  public onTextBoxCreateGenericName(args) {

    const val = (this.ipeGenericName as any).value;
    const ctrl = (this.ipeGenericName as any).containerEle.querySelector(
      '.e-textbox'
    ).ej2_instances[0];

    if (val) {
      (this.ipeGenericName as any).containerEle.querySelector(
        '.e-textbox'
      ).ej2_instances[0].value = this.decodeHtml(val);
    } else {
      ctrl.value = '';
    }
  }

  public onTextBoxCreateDosage(args) {
    (this.ipeDosage as any).containerEle.querySelector(
      '.e-ddl'
    ).ej2_instances[0].value = this.decodeHtml((this.ipeDosage as any).value);
  }

  public encodeHtml(str) {
    const buf = [];
    if (str) {
      for (let i = str.length - 1; i >= 0; i--) {
        buf.unshift(['&#', str[i].charCodeAt(), ';'].join(''));
      }

      return buf.join('');
    }
  }

  public decodeHtml(str) {

    if (str) {
      return str.replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
      });
    }
  }

    editorChanged(event) {
        const column = event.data.name;
        const value = event.data.value;

        switch (column) {

            case 'selectedDosage':

                if (this.partIndex !== null && this.partIndex >= 0) {

                    // this is a name of a part, not a Product or a Kit
                    this.llFormData[0].data.products[this.prodIndex].parts[this.partIndex].dosageForm = value ? this.getGenericKeyObject('dosageform', value) : null;
                } else {

                    this.llFormData[0].data.products[this.prodIndex].dosageForm = value ? this.getGenericKeyObject('dosageform', value) : null;
                }

                this.frmProductDetails.patchValue({
                    selectedDosage: value
                });

                break;
            case 'genericName':

                if (this.partIndex !== null && this.partIndex >= 0) {

                    // this is a name of a part, not a Product or a Kit
                    this.llFormData[0].data.products[this.prodIndex].parts[this.partIndex].estGenName = value;
                } else {

                    this.llFormData[0].data.products[this.prodIndex].estGenName = value;
                }

                this.frmProductDetails.patchValue({
                    genericName: value
                });

                break;

            case 'proprietaryNameSuffix':

                if (this.partIndex !== null && this.partIndex >= 0) {

                    // this is a name of a part, not a Product or a Kit
                    this.llFormData[0].data.products[this.prodIndex].parts[this.partIndex].proprietaryNameSuffix = value;
                } else {

                    this.llFormData[0].data.products[this.prodIndex].proprietaryNameSuffix = value;
                }

                this.frmProductDetails.patchValue({
                    proprietaryNameSuffix: value
                });

                break;

            case 'proprietaryName':

                if (this.partIndex !== null && this.partIndex >= 0) {

                    // this is a name of a part, not a Product or a Kit
                    this.llFormData[0].data.products[this.prodIndex].parts[this.partIndex].proprietaryName = value;
                } else {

                    this.llFormData[0].data.products[this.prodIndex].proprietaryName = value;
                }

                this.frmProductDetails.patchValue({
                    proprietaryName: value
                });
                break;
        }

        this.frmProductDetails.markAsDirty();
    }


    populateControls() {

        if (this.dataProductDetail.dosageForm && +this.dataProductDetail.dosageForm.id) {

            this.selectedDosageValue = this.dataProductDetail.dosageForm.label;
            this.selectedDosageId = +this.dataProductDetail.dosageForm.id;
        } else {

            this.selectedDosageValue = null;
            this.selectedDosageId = null;
        }

        if (this.dataProductDetail) {
          this.frmProductDetails.patchValue({
              proprietaryName: this.encodeHtml(this.dataProductDetail.proprietaryName),
              proprietaryNameSuffix: this.encodeHtml(this.dataProductDetail.proprietaryNameSuffix),
              genericName: this.encodeHtml(this.dataProductDetail.estGenName),
              selectedDosage: this.selectedDosageId
          });
      }

        if (this.ipeDosage) {

            this.ipeDosage.value = this.selectedDosageId;
        }

        this.llService.llFormProductDetailsSubject.next(this.frmProductDetails.value);
    }


    // retrieve data and populate controls on the component
    loadData() {
        if (this.frmProductDetails) {
            this.frmProductDetails.reset();

            if (this.llFormData) {
                if (this.llFormData[1] && this.llFormData[1]['data']) {
                    this.allLOV = this.llFormData[1]['data'];
                    this.dosageFormLOV = this.getLOVDataByType('dosageform');

                    this.dosageFormModel = {
                        placeholder: 'Select Dosage Form',
                        dataSource: this.dosageFormLOV,
                        fields: { value: 'id', text: 'label' },
                      width: '450px'
                    // , created: this.onTextBoxCreateDosage.bind(this)

                    };
                }

                if (this.llFormData[0] && this.llFormData[0]['data']) {
                    this.dataProductDetail = this.llFormData[0]['data']['products'][this.prodIndex];
                    if ((this.partIndex || this.partIndex === 0) && this.llFormData[0]['data']['products'][this.prodIndex]['parts']) {
                        this.dataProductDetail = this.llFormData[0]['data']['products'][this.prodIndex]['parts'][this.partIndex];
                    }
                    if (this.dataProductDetail) {
                        const dosageFormId = this.dataProductDetail.dosageForm ? (+this.dataProductDetail.dosageForm.id === 0 ? null : +this.dataProductDetail.dosageForm.id) : null;
                        this.selectedDosageId = dosageFormId;
                    }

                    this.populateControls();
                }
            }
        }
    }

    // when form data changed from the parent, refresh the component
  ngOnChanges(changes: SimpleChanges) {
        // eslint-disable-next-line guard-for-in
        for (const property in changes) {
            if (property === 'llFormData' || property === 'prodIndex' || property === 'partIndex' || property === 'productId') {
                this.loadData();
            }
        }
    }

    // Get a list of LOVs by doc_type, created a new column that will
    // concatenate label and code fields for displaying purpose
    getLOVDataByType(type: string): any[] {
        const dataLOV = this.allLOV.filter(x => x.vocaB_TYPE === type);
        const newLOV = dataLOV.map(item => {
            const container = {};
            container['id'] = item.id;
            container['label'] = `${ item.label } (${ item.code })`;
            return container;
        });
        return newLOV;
    }

    getGenericKeyObject(type: string, id: any): ILLGenericKeys {

        let retVal: ILLGenericKeys;
        let data: any;
        let list: ILLGenericKeys[];

        if (this.llFormData[1]) {

            data = this.llFormData[1]['data'];

            list = data.filter(x => x.vocaB_TYPE === type);

            if (list && list.length > 0) {

                retVal = list.find(v => +v.id === +id);
            }
        }

        return retVal;
    }
}


